import { useContext } from "react";

import { CustomIntlContext } from "src/internationalization/CustomIntlProvider.tsx";

export const useT = () => useContext(CustomIntlContext).t;
